const IsProductPageValues = {
  TRUE: 'true',
  FALSE: 'false',
};

module.exports = IsProductPageValues;
